module.exports = __webpack_public_path__ + "img/explicacao7.a9f1ebfb.png";